import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Grid, Autocomplete, TextField, InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Search = forwardRef(({ onSelect }, ref) => {
  const [items, setItems] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [open, setOpen] = useState(false);

  const API_TOKEN = process.env.REACT_APP_API_TOKEN || "";

  useImperativeHandle(ref, () => ({
    clear: () => {
      setBusqueda("");
      setItems([]);
      setOpen(false);
      onSelect(null);
    },
  }));

  useEffect(() => {
    if (busqueda.length < 2) {
      setItems([]);
      return;
    }

    (async () => {
      try {
        const resp = await fetch(`/proformas/buscar-items/?q=${encodeURIComponent(busqueda)}`, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });
        const { results = [] } = await resp.json();
        setItems(results);
      } catch {
        setItems([]);
      }
    })();
  }, [busqueda, API_TOKEN]);

  const getCodigoPrincipal = (item) => {
    if (item?.type === "product" && item?.variant_id && item?.code && item?.sku) {
      return `${item.code}-${item.sku}`;
    }
    return item?.code || "";
  };

  const optionLabel = (opt) => {
    if (!opt) return "";
    if (typeof opt === "string") return opt;

    if (opt.type === "product" && opt.variant_id) {
      const baseName = (opt.name || "").split(" (")[0];
      return `${opt.code} ${baseName} (${opt.sku} ${opt.value})`;
    }

    return `${opt.code || ""} ${opt.name || ""}`.trim();
  };

  const handleSelect = (_, item) => {
    if (item) {
      const selectedItem = {
        ...item,
        codigo_principal: getCodigoPrincipal(item),
        codigo_auxiliar: item.codigo_auxiliar || "",
      };
      onSelect(selectedItem);
      setBusqueda(optionLabel(selectedItem));
    } else {
      onSelect(null);
      setBusqueda("");
    }
    setOpen(false);
  };

  const clearAll = () => {
    ref.current?.clear();
  };

  return (
    <Grid item xs={12} md={6}>
      <Autocomplete
        options={items}
        filterOptions={(x) => x}
        getOptionLabel={optionLabel}
        inputValue={busqueda}
        onInputChange={(_, v, reason) => {
          if (reason === "input") {
            setBusqueda(v);
            setOpen(v.length >= 2);
          }
        }}
        open={open}
        onChange={handleSelect}
        noOptionsText="Sin resultados"
        freeSolo
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Buscar producto o servicio"
            fullWidth
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={clearAll} edge="end">
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
});

export default Search;